import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface CollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
}
export function CollapsibleSection({
  title,
  children,
  defaultOpen = true,
  className = ''
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className={`bg-white border border-gray-200 rounded-lg overflow-hidden ${className}`} data-id="element-10">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between px-6 py-4 bg-gray-50 border-b border-gray-100 hover:bg-gray-100 transition-colors text-left" data-id="element-11">
        <h3 className="text-sm font-semibold text-gray-700" data-id="element-12">{title}</h3>
        {isOpen ? <ChevronUp className="w-4 h-4 text-gray-500" data-id="element-13" /> : <ChevronDown className="w-4 h-4 text-gray-500" data-id="element-14" />}
      </button>

      {isOpen && <div className="p-6" data-id="element-15">{children}</div>}
    </div>;
}